// extracted by mini-css-extract-plugin
module.exports = {"root":"CbSignUpSettings_root__2STNs","section":"CbSignUpSettings_section__2Pa12"};